module.exports = __webpack_public_path__ + "static/media/unum.ba25fba0.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/images/partner/logos/unum.png
// module id = 41
// module chunks = 0